// removed by extract-text-webpack-plugin
module.exports = {"address":"_10nutCi3"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy/privacy-page.styles.scss
// module id = 298
// module chunks = 0